import React from 'react';
import { Icon } from './Icon.js';
export const IconSavedItems = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("polygon", { points: "7 3 13 3 13 11 10 8 7 11 7 3", fill: "currentColor", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", "data-color": "color-2" }),
        React.createElement("rect", { x: "3", y: "3", width: "14", height: "14", rx: "3", ry: "3", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" })));
};
//# sourceMappingURL=IconSavedItems.js.map